import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const adminApi = createApi({
  reducerPath: "adminApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "", // adjust if needed
    prepareHeaders: (headers) => {
      const tokens = JSON.parse(sessionStorage.getItem("tokens") || "{}");
      const apiKey = JSON.parse(sessionStorage.getItem("api_key") || "{}");

      if (tokens?.access_token) {
        headers.set("Authorization", `Bearer ${tokens.access_token}`);
      }

      if (apiKey?.user_api_key) {
        headers.set("User_api_key", apiKey.user_api_key);
      }

      return headers;
    },
  }),
  tagTypes: ["Users"],
  endpoints: (builder) => ({
    getPendingUsers: builder.query({
      query: () => "/user/pending",
      providesTags: ["Users"],
    }),

    approveUser: builder.mutation({
      query: (userId) => ({
        url: `/user/${userId}/approve`,
        method: "PATCH",
      }),
      invalidatesTags: ["Users"],
    }),

    rejectUser: builder.mutation({
      query: (userId) => ({
        url: `/user/${userId}/reject`,
        method: "PATCH",
      }),
      invalidatesTags: ["Users"],
    }),
  }),
});

export const {
  useGetPendingUsersQuery,
  useApproveUserMutation,
  useRejectUserMutation,
} = adminApi;